///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq_transfers = abcsetup.rfq_transfers || {};
abcsetup.rfq_transfers.index = abcsetup.rfq_transfers.index || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////

abcsetup.rfq_transfers.index = {
    init: function() {

        $(document).on('click', '.action-button', function(e) {
            abcsetup.blockUI();

            $.get('/rfq_transfers/'+$(this).data('id'), function(response) {
                if ($('#bidDataModal')) {
                    $('#bidDataModal').remove();
                }
                
                $('body').append(response);
                $('#bidDataModal').modal('show');
                abcsetup.unblockUI(true);
            });
        });
    }
}